



"use strict";



export default function scrollIntoView (elem) {
    if ( !elem ) return;

    const bodyRect = document.body.getBoundingClientRect(),
          elemRect = elem.getBoundingClientRect(),
          offset   = elemRect.top - bodyRect.top;

    window.scrollTo({
        top: offset,
        behavior: 'smooth',
    });
}
